import { PropsWithChildren, useEffect, useMemo, useState } from 'react'
import { DarkModeContext } from '../contexts/DarkModeContext'

const DarkModeProvider = ({ children }: Readonly<PropsWithChildren>) => {
  const prefersDarkMode =
    typeof globalThis !== 'undefined' &&
    globalThis.matchMedia('(prefers-color-scheme: dark)')?.matches
  const [darkMode, setDarkMode] = useState<boolean>(prefersDarkMode)

  useEffect(() => {
    if (typeof globalThis === 'undefined') return

    const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (event: MediaQueryListEvent) => {
      setDarkMode(event.matches)
    }

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.classList.toggle('dark', darkMode)
    }
  }, [darkMode])

  const value = useMemo(
    () => ({
      darkMode,
      setDarkMode
    }),
    [darkMode]
  )

  return (
    <DarkModeContext.Provider value={value}>
      {children}
    </DarkModeContext.Provider>
  )
}

export { DarkModeContext } from '../contexts/DarkModeContext'
export { DarkModeProvider }
export default DarkModeProvider
